import { type FC } from 'react'

import { LABELS } from '@/constants/common/message.constants'

type Props = {
  contactName?: string | null
  phoneNumber?: string | null
}

/**
 * 閲覧専用表示の地点に添える担当者・連絡先（#5264 VOC_PJ-1000）。
 * どちらも地点マスタで任意入力なので、入っている項目だけを出し、
 * 両方空なら何も描かず住所までの体裁を変えない。
 */
export const SiteContactText: FC<Props> = ({ contactName, phoneNumber }) => {
  if (!contactName && !phoneNumber) return null

  return (
    <p className="text-neutral-7 flex items-center gap-3">
      {contactName && (
        <span>
          {LABELS.CONTACT_NAME}：{contactName}
        </span>
      )}
      {phoneNumber && (
        <span>
          {LABELS.CONTACT_PHONE_NUMBER}：{phoneNumber}
        </span>
      )}
    </p>
  )
}
